import { Spinner, Td, Tr } from "@chakra-ui/react";

export function TableLoadingRow({ colSpan, loading }: { colSpan: number; loading: boolean }) {
  if (!loading) return null;

  return (
    <Tr>
      <Td colSpan={colSpan}>
        <Spinner />
      </Td>
    </Tr>
  );
}
